import Grid from '@mui/material/Grid';
import { FormInput } from '../../../components/hook-form/form-input.component';

export const ProjectSubtypeForm = () => {
  return (
    <Grid container spacing={2}>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput label="Project Subtype" name="projectSubType" maxLength={150} autoFocus />
      </Grid>
    </Grid>
  );
};
